export function flashMessage() {
    const match = document.cookie.match(/(?:^|;\s*)flash_data=([^;]*)/);
    if (!match) return;

    let data;
    try {
        data = JSON.parse(decodeURIComponent(match[1]));
    } catch (e) {
        return;
    }

    if (Array.isArray(data.validation_errors) && data.validation_errors.length > 0) {
        createFlashMessage(data.validation_errors, 'error');
    }

    if (data.flash?.error) {
        createFlashMessage(data.flash.error, 'error');
    }

    if (data.flash?.success) {
        createFlashMessage(data.flash.success, 'success');
    }

    if (data.flash?.warning) {
        createFlashMessage(data.flash.warning, 'info');
    }
}
